import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IonInput, ToastController } from '@ionic/angular';
import { ApiProvider } from 'src/app/services/api-providers/api-provider';
import { AuthProviderService } from 'src/app/services/api-providers/auth-provider.service';
import { GoogleMapsAutocompleteService } from 'src/app/services/google-maps-autocomplete.service';

@Component({
  selector: 'app-form-inscription',
  templateUrl: './form-inscription.component.html',
  styleUrls: ['./form-inscription.component.scss'],
  animations: [
    trigger('fadeInOut', [
      state('void', style({ position: 'absolute', width: '100%' })),
      state('*', style({ position: 'absolute', width: '100%' })),
      transition(':enter', [
        style({ transform: 'translateX(-100%)', opacity: 0 }),
        animate('0.5s ease-in', style({ transform: 'translateX(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ transform: 'translateX(0)', opacity: 1 }),
        animate('0.5s ease-out', style({ transform: 'translateX(100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class FormInscriptionComponent implements OnInit {

  inscriptionForm: FormGroup;
  activeStep: string;
  suggestedAddresses: any[] = [];
  validRegistration: boolean = false;

  constructor(
    private router: Router,
    private authProvider: AuthProviderService,
    private autocompleteService: GoogleMapsAutocompleteService,
    private ngZone: NgZone,
    private toastController: ToastController,
    private apiProvider: ApiProvider
  ) { }

  ngOnInit() {
    this.activeStep = "account";
    this.inscriptionForm = new FormGroup({
      Email: new FormControl('', [Validators.required, Validators.email]),
      Password: new FormControl('', [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}')]),
      ConfirmPassword: new FormControl('', [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}')])
    }, { validators: this.checkPasswords });
  }

  get passwordErrorMessage() {
    const passwordControl = this.inscriptionForm.get('Password');
    if (passwordControl?.hasError('required')) {
      return 'Le mot de passe est requis';
    }
    return 'Le mot de passe doit contenir au moins 8 caractères, dont une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial ($@$!%*?&)';
  }

  get confirmPasswordErrorMessage() {
    const confirmPasswordControl = this.inscriptionForm.get('ConfirmPassword');
    if (confirmPasswordControl?.hasError('required')) {
      return 'La confirmation du mot de passe est requise';
    }
    return 'Les mots de passe ne correspondent pas ou ne respectent pas les critères';
  }

  onSubmit() {
    // TODO: Use EventEmitter with form value
    if (this.inscriptionForm.valid) {
      this.authProvider.createCoach(this.inscriptionForm.value).subscribe(
        (data: Boolean) => {
          if (data) {
            this.validRegistration = true
          }
        },
        async (err: any) => {
          console.log(err);
          if (err.error.message == "User already exists!") {
            const toast = await this.toastController.create({
              message: "L'email saisi est déjà lié à un compte.",
              duration: 5000,
              buttons: [
                {
                  text: 'Ok',
                  role: 'cancel'
                }
              ]
            });
            await toast.present();
          }
        }
      )
    }

  }

  checkPasswords: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
    let pass = group.get('Password').value;
    let confirmPass = group.get('ConfirmPassword').value
    return pass === confirmPass ? null : { notSame: true }
  }

  redirect(url : string = "") {
    this.router.navigateByUrl(url);
  }

  changeStep(step: string) {
    this.activeStep = step
  }

  disableFirstStep() {
    const passwordControl = this.inscriptionForm.controls["Password"];
    const confirmPasswordControl = this.inscriptionForm.controls["ConfirmPassword"];

    if (passwordControl.value && confirmPasswordControl.value && passwordControl.value === confirmPasswordControl.value) {
      return false; // Le bouton n'est pas désactivé
    } else {
      return true; // Le bouton est désactivé
    }
  }

}
